require("-!/tmp/build_a8e9f79c/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!less-loader!/tmp/build_a8e9f79c/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/tmp/build_a8e9f79c/src/theme/font-awesome.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.config.prod.js
// module id = 951
// module chunks = 0